export default __webpack_public_path__ + "static/media/checkin.c4d63623.png";